import { Box, Button, IconButton  } from '@mui/material'
import React, { useState, useRef } from 'react'
import ReactPlayer from 'react-player'
import { MenuIcon } from '../../../../../core/icon/__refactored/Icon'
import { PlayArrow, Pause } from '@mui/icons-material';
import { useEffect } from 'react';
import { rqx } from '../../../../../core/request/API';
import { env } from '../../../../../core/Env';
import { useSnackbar } from '../../../../../core/context/SnackbarContext';



export const VL = ({openWidth, wideHandler, uid, nav, information_state, tool_state}) => {
    const { showSnackbar } = useSnackbar();
    let urlParams = new URLSearchParams(window.location.search);
    const [showOverlay, setShowOverlay] = useState(false);
    const [dsbld, setDsbld] = useState(true);
    const [playing, setPlaying] = useState(false);
    const [link, setlink] = useState('');
    const playerRef = useRef(null);

    const onPause = (e) => {
      setShowOverlay(true);
    };
  
    const onPlay = (e) => {
      setShowOverlay(false);
    };

    const handlePlayPause = () => {
        setPlaying(!playing);
    };

    const onEnded = async() => {
        const init = await rqx.post(`<<tool>>/${env()}/biz_exam/exam_vl_create`, {training_id:urlParams.get('id'), user_id:uid, exam_type:4, company_id: tool_state.cinfo.data[0].company_id})
        if(init.message === 'success') {
            await _init()
            setDsbld(false);
        }
    };

    const handleNext = async() => {
        // eslint-disable-next-line
        try {
            const updateStatus = await rqx.post(`<<tool>>/${env()}/biz_exam/user_update_status`, {training_id:urlParams.get('id'), user_id:uid, company_id: tool_state.cinfo.data[0].company_id})
            const init = await rqx.post(`<<tool>>/${env()}/biz_exam/exam_vl_create`, {training_id:urlParams.get('id'), user_id:uid, exam_type:4, company_id: tool_state.cinfo.data[0].company_id})
            if (init.message !== 'success') throw new Error("Failed");
            showSnackbar("Saved successfully!", "success");
            _init()
            handleNextResult(init)
        } catch (err) {
            console.log(err)
            showSnackbar("Something went wrong!", "error");
        }

        
    };

    const handleNextResult = (result) => {
        if(result.message === 'success') {
            // nav.push(`/take-training-course/quiz?id=${urlParams.get('id')}`)
            if (information_state.tc.data.pretest !== null && information_state.prog.data.pretest === 0){
                // console.log(1)
                // return
                nav.push(`/biz/take-training/pretest?id=${urlParams.get('id')}`)
            } else if (information_state.tc.data.vl !== null && information_state.prog.data.vl === 0) {
                // console.log(2)
                // return
                nav.push(`/biz/take-training/video-lesson?id=${urlParams.get('id')}`)
            } else if (information_state.tc.data.quiz !== null && information_state.prog.data.quiz === 0) {
                // console.log(3)
                // return
                nav.push(`/biz/take-training/quiz?id=${urlParams.get('id')}`)
            } else if (information_state.tc.data.posteval !== null && information_state.prog.data.posteval === 0) {
                // console.log(4)
                // return
                nav.push(`/biz/take-training/post-evaluation?id=${urlParams.get('id')}`)
            }
        }
    }


    const _init = async() =>{
        const init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_VL`, {training_id:urlParams.get('id'), ref:'trainings', company_id: tool_state.cinfo.data[0].company_id})
        const progress = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_check_trainings`, {training_id:urlParams.get('id'), user_id: uid, ref:'trainings', company_id: tool_state.cinfo.data[0].company_id })
        const tContent = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_training_content`, {training_id:urlParams.get('id'), ref:'trainings'})
        const updatedProg = { pretest: 1, vl: 0, quiz: 0, posteval: 0 };
        progress.forEach(item => {
            if (item.exam_type === 1) {
            // pretest
            updatedProg.pretest = item.exam_type === 1 ? 1 : 0;
            } else if (item.exam_type === 2) {
            // quiz
            updatedProg.quiz = item.exam_type === 2 ? 1 : 0;
            } else if (item.exam_type === 3) {
            // post eval
            updatedProg.posteval = item.exam_type === 3 ? 1 : 0;
            } else if (item.exam_type === 4) {
            // video Lesson
            updatedProg.vl = item.exam_type === 4 ? 1 : 0;
            }
        });
        information_state.prog.set(updatedProg)
        information_state.tc.set({...information_state.tc.data, pretest:tContent[0].pretest_id !== null ? 1 : null, quiz:tContent[0].quiz_id !== null? 1: null, posteval:tContent[0].post_evaluation_id !== null ? 1 : null})
        setlink(init)
    }
    useEffect(() => {
        information_state.test.set({...information_state.test.data, name:'Video Lesson'})
        _init()
        const handleKeyDown = (e) => {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault();
          }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box p="40px" display="flex" flexDirection="column" width="100%" height="100%">
            <Box display="flex" justifyContent="flex-end" alignItems="center" mb="24px">
                { !openWidth.data && (
                    <Box display="flex" className='c-pointer' onClick={wideHandler}>
                        <MenuIcon />
                        <Box fontSize={14} fontWeight={600} lineHeight="22.65px" color="#1893F1" ml="12px">Show menu</Box>
                    </Box>
                    )
                }
            </Box>

            <Box className="player-wrapper" position="relative">
                {showOverlay && <Box className="player-overlay-morevdo"></Box>}
                <ReactPlayer
                ref={playerRef}
                url={link.video_link}
                playing={playing}
                onPlay={onPlay}
                onPause={onPause}
                controls={true}
                // controls={false}
                onEnded={onEnded}
                width="100%"
                height="505px"
                />
                <Box position="absolute" bottom="10px" left="10px">
                <IconButton onClick={handlePlayPause} color="primary">
                    {playing ? <Pause /> : <PlayArrow />}
                </IconButton>
                </Box>
            </Box>
            <Box display="flex" justifyContent="flex-end" mt="56px">
                <Box component={Button} onClick={()=>handleNext()} disabled={dsbld} variant="contained" bgcolor='#1893F1' color="primary" sx={{display:'flex', alignItems:'center', borderRadius: '6px', height:'44px', width:'80px', boxShadow: 'none'}} >Next</Box>
            </Box>
        </Box>
    )
}